/* Application environment
 ========================================================================== */

var utils = {},
    app = {},
    template = {};

/* Define jQuery in noConflict mode */
$ = jQuery.noConflict();